import React from 'react';
import Icon from '../../../components/AppIcon';

const TEMPLATES = {
  sites: {
    filename: 'sites_template.csv',
    headers: ['site_name', 'site_reference', 'address_line1', 'city', 'postcode', 'client_name', 'client_contact_person', 'client_email', 'client_phone', 'status (active, planning, on_hold, completed, archived)', 'start_date', 'end_date'],
    example: ['Riverside Development', 'RD-001', '123 Main Street', 'London', 'SW1A 1AA', 'Acme Corp', 'John Smith', 'john@acme.com', '07700900000', 'active', '2026-01-01', '2026-12-31'],
  },
  users: {
    filename: 'users_template.csv',
    headers: ['full_name', 'email', 'role (admin, site_manager, worker)'],
    example: [
      ['Heidi Tripp', 'heidi@example.com', 'admin'],
      ['Tom Builder', 'tom@example.com', 'site_manager'],
      ['Jane Worker', 'jane@example.com', 'worker'],
    ],
  },
  workers: {
    filename: 'workers_template.csv',
    headers: ['full_name', 'email', 'phone', 'trade', 'cscs_card_number', 'cscs_expiry_date'],
    example: ['Jane Doe', 'jane@example.com', '07700900001', 'Electrician', 'CSCS123456', '2027-06-30'],
  },
  tasks: {
    filename: 'tasks_template.csv',
    headers: ['title', 'description', 'site_name', 'task_date', 'category', 'status', 'photo_required'],
    example: ['Morning Safety Check', 'Check all safety equipment', 'Riverside Development', '2026-03-10', 'Safety', 'pending', 'false'],
  },
  certifications: {
    filename: 'certifications_template.csv',
    headers: ['workerEmail', 'certificationType', 'certificateNumber', 'issuedDate', 'expiryDate'],
    example: ['jane@example.com', 'CSCS Card', 'CSCS123456', '2024-01-15', '2027-01-14'],
  },
  documents: {
    filename: 'documents_template.csv',
    headers: ['documentName', 'category', 'siteName', 'issueDate', 'expiryDate', 'owner'],
    example: ['Public Liability Insurance', 'insurance', 'Riverside Development', '2026-04-01', '2027-03-31', 'Acme Corp'],
  },
  snags: {
    filename: 'snags_template.csv',
    headers: ['siteName', 'description', 'priority', 'assignedWorker', 'status', 'dueDate'],
    example: ['Riverside Development', 'Cracked render on north elevation', 'medium', 'jane@example.com', 'open', '2026-04-30'],
  },
};

const TemplateDownloadButton = ({ type }) => {
  const template = TEMPLATES?.[type];

  const handleDownload = () => {
    if (!template) return;
    // Support multi-row examples (array of arrays) or single-row (flat array)
    const exampleRows = Array.isArray(template?.example?.[0]) ? template?.example : [template?.example];
    const rows = [template?.headers, ...exampleRows];
    // RFC 4180 escape: wrap any field containing comma, quote, CR or LF in
    // double quotes and double any embedded quotes. Without this, headers like
    // `status (active, planning, ...)` get split into multiple columns.
    const escape = (v) => {
      const s = v == null ? '' : String(v);
      return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const csvContent = rows?.map(r => r?.map(escape)?.join(','))?.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL?.createObjectURL(blob);
    const link = document?.createElement('a');
    link.href = url;
    link?.setAttribute('download', template?.filename);
    document?.body?.appendChild(link);
    link?.click();
    document?.body?.removeChild(link);
    URL?.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleDownload}
      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-accent border border-accent rounded-lg hover:bg-accent hover:text-white transition-colors"
    >
      <Icon name="Download" size={16} />
      Download CSV Template
    </button>
  );
};

export default TemplateDownloadButton;
